import { isEmpty } from 'lodash'
import Fuse from 'fuse.js'
import { withRouter } from 'react-router'

import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { compose, withHandlers, withStateHandlers, withPropsOnChange } from 'recompose'

import withOrgTeams from 'app/modules/teams/hoc/withOrgTeams'
import withNotifications from 'components/shared/notifications'
import withOrgTeamAvailabilities from 'app/modules/teams/hoc/withOrgTeamAvailabilities'

import { deleteOrgTeam } from 'app/modules/teams/actions'

import TeamsList from './component'

const FUSE_OPTIONS = {
  keys: ['name'],
  caseSensitive: false,
  includeScore: false,
  shouldSort: true,
  tokenize: false,
  threshold: 0.2,
  location: 0,
  distance: 100,
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      deleteOrgTeam,
    },
    dispatch
  ),
})

export default compose(
  withRouter,
  withOrgTeams,
  withNotifications,
  withOrgTeamAvailabilities,
  connect(null, mapDispatchToProps),
  withStateHandlers(
    {
      visibleTeams: [],
      teamsCorpus: [],
      searchResultsEmpty: false,
      teamsEmpty: true,
      showCreateModal: false,
      showDeleteModal: false,
      deletingTeamId: null,
    },
    {
      setEmptySearchState: () => teams => ({
        visibleTeams: teams,
        searchResultsEmpty: false,
      }),
      setSearchState: () => results => ({
        visibleTeams: results, // results = list of teams matching term
        searchResultsEmpty: results.length === 0,
      }),
      refreshTeamsState: () => teams => ({
        visibleTeams: teams,
        teamsCorpus: new Fuse(teams, FUSE_OPTIONS),
        teamsEmpty: teams.length === 0,
      }),
      openTeamCreateModal: () => () => ({ showCreateModal: true }),
      openTeamDeleteModal: () => id => ({
        showDeleteModal: true,
        deletingTeamId: id,
      }),
      resetModals: () => () => ({
        showCreateModal: false,
        showDeleteModal: false,
        deletingTeamId: null,
      }),
    }
  ),
  withPropsOnChange(['teams'], ({ teams, refreshTeamsState }) => {
    refreshTeamsState(teams)
  }),
  withPropsOnChange(['deleteTeamSuccess', 'deleteTeamFailed'], ({ deleteTeamSuccess, deleteTeamFailed }) => {
    if (deleteTeamSuccess) this.onDeleteTeamSuccess()
    if (deleteTeamFailed) this.onDeleteTeamFailed()
  }),
  withHandlers({
    onTeamSearch: ({ teams, teamsCorpus, setEmptySearchState, setSearchState }) => e => {
      const searchTerm = e.target.value
      if (isEmpty(searchTerm)) {
        setEmptySearchState(teams)
      } else {
        const searchResults = teamsCorpus.search(searchTerm)
        setSearchState(searchResults)
      }
    },
    onConfirmDelete: ({ actions, teams, deletingTeamId, resetModals, notifications }) => () => {
      actions.deleteOrgTeam({ teamId: deletingTeamId })
      resetModals()
      const deletedTeam = teams.find(team => team.id === deletingTeamId)
      notifications.success(`Team "${deletedTeam.name}" was successfully deleted!`)
    },
  })
)(TeamsList)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/Teams/TeamsList/index.js